import { css } from '@emotion/react';
import { FC, ReactNode } from 'react';
import { ContextProps, FormControlContext } from './FormControlContext';

export interface FormControlProps extends ContextProps {
  children: ReactNode;
}

const formControlStyles = css({
  display: 'flex',
  flexDirection: 'column',
});

export const FormControl: FC<FormControlProps> = ({
  children,
  controlId,
  isInvalid = false,
  isDisabled = false,
  isVerified = false,
  isCompleted = false,
}: FormControlProps) => {
  const context: ContextProps = {
    controlId,
    isInvalid,
    isDisabled,
    isVerified,
    isCompleted,
  };

  return (
    <FormControlContext.Provider value={context}>
      <div css={formControlStyles}>{children}</div>
    </FormControlContext.Provider>
  );
};

FormControl.displayName = 'FormControl';
